module.exports = __webpack_public_path__ + "img/upgrade.d733846e.svg";